"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.getFirstIndexFromPage = exports.withPropsFunc = exports.getCurrentPage = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var Dropdown2_1 = require("../Dropdown2");
var Tooltip_1 = require("../Tooltip");
var Icon_1 = require("../Icon");
var Button_1 = require("../Button");
var translation_1 = require("../../utils/translation");
var getCurrentPage = function (props) {
    if (props.limit === 0 || props.total === 0) {
        return 1;
    }
    else {
        return 1 + Math.floor(props.offset / props.limit);
    }
};
exports.getCurrentPage = getCurrentPage;
var withPropsFunc = function (props) {
    var lastPossiblePage = Math.max(1, Math.ceil(props.total / props.limit));
    var numberOfPages = Math.min(props.maximumNumberOfPages, Math.max(1, lastPossiblePage));
    var currentPage = (0, exports.getCurrentPage)(props);
    var firstPageNumber = Math.max(1, Math.min(lastPossiblePage - numberOfPages + 1, currentPage - Math.floor(numberOfPages / 2)));
    var pagesDisplayed = new Array(numberOfPages)
        .fill(0)
        .map(function (_, i) { return i + firstPageNumber; });
    return __assign(__assign({}, props), { pagesDisplayed: pagesDisplayed, lastPossiblePage: lastPossiblePage, currentPage: currentPage });
};
exports.withPropsFunc = withPropsFunc;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Pagination'), (0, recompose_1.defaultProps)({
    maximumNumberOfPages: 9,
    limitOptions: [20, 50, 100],
    limit: 20,
    displayDropdown: true
}), (0, recompose_1.withProps)(exports.withPropsFunc), recompose_1.pure);
var getFirstIndexFromPage = function (pageNumber, limit) {
    return (pageNumber - 1) * limit;
};
exports.getFirstIndexFromPage = getFirstIndexFromPage;
exports.Pagination = enhance(function (props) { return (React.createElement("div", { className: classNames('sok-pagination', props.className) },
    props.displayDropdown && (React.createElement(Dropdown2_1.Dropdown2, { alignment: "left", direction: props.dropdownDirection || 'up' },
        React.createElement(Button_1.Button, { text: props.limit.toString(), icon: React.createElement(Icon_1.Icon, { className: "fa-list" }), iconRight: React.createElement(Icon_1.Icon, { className: props.dropdownDirection === 'down'
                    ? 'fa-angle-down'
                    : 'fa-angle-up' }), title: (0, translation_1.getLocalization)('components/Pagination/showItemsPerPage', [
                props.limit + ''
            ]), color: "dark-gray" }),
        React.createElement(Dropdown2_1.Dropdown2Menu, null, props.limitOptions.map(function (itemsPerPage) { return (React.createElement(Dropdown2_1.Dropdown2MenuItem, { key: itemsPerPage, onClick: function () {
                props.updatePageState(0, itemsPerPage);
            } }, (0, translation_1.getLocalization)('components/Pagination/itemsPerPage', [
            itemsPerPage + ''
        ]))); })))),
    React.createElement("div", { className: 'sok-pagination-page-container' },
        React.createElement(Tooltip_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('components/Pagination/firstPage')) },
            React.createElement(Button_1.Button, { className: "sok-pagination-page-number-button first-page", color: 'dark-gray', disabled: props.currentPage === 1, onClick: function () { return props.updatePageState(1, props.limit); } },
                React.createElement(Icon_1.Icon, { className: "fa-angle-double-left" }))),
        React.createElement("div", { className: "sok-pagination-page-buttons" },
            React.createElement(Button_1.Button, { className: "sok-pagination-prev-button", color: "dark-gray", onClick: function () {
                    return props.updatePageState((0, exports.getFirstIndexFromPage)(props.currentPage - 1, props.limit), props.limit);
                }, disabled: props.currentPage === 1 },
                React.createElement(Icon_1.Icon, { className: "fa-chevron-left" })),
            React.createElement("div", { className: "sok-pagination-page-number-buttons" },
                props.pagesDisplayed.map(function (pageNum) { return (React.createElement(Button_1.Button, { key: pageNum, className: "sok-pagination-page-number-button", color: pageNum === props.currentPage ? 'blue' : 'dark-gray', onClick: function () {
                        return props.updatePageState((0, exports.getFirstIndexFromPage)(pageNum, props.limit), props.limit);
                    } }, pageNum)); }),
                props.lastPossiblePage - props.currentPage >= 10 && (React.createElement(Tooltip_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('components/Pagination/next10Pages')) },
                    React.createElement(Button_1.Button, { className: "sok-pagination-page-number-button", color: 'dark-gray', onClick: function () {
                            return props.updatePageState((0, exports.getFirstIndexFromPage)(props.currentPage + 10, props.limit), props.limit);
                        } }, '...')))),
            React.createElement(Button_1.Button, { className: "sok-pagination-next-button", color: "dark-gray", onClick: function () {
                    return props.updatePageState((0, exports.getFirstIndexFromPage)(props.currentPage + 1, props.limit), props.limit);
                }, disabled: props.currentPage === props.lastPossiblePage },
                React.createElement(Icon_1.Icon, { className: "fa-chevron-right" }))),
        React.createElement(Tooltip_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('components/Pagination/lastPage')) },
            React.createElement(Button_1.Button, { className: "sok-pagination-page-number-button last-page", color: 'dark-gray', disabled: props.currentPage === props.lastPossiblePage, onClick: function () {
                    return props.updatePageState((0, exports.getFirstIndexFromPage)(props.lastPossiblePage, props.limit), props.limit);
                } },
                React.createElement(Icon_1.Icon, { className: "fa-angle-double-right" })))))); });
//# sourceMappingURL=index.js.map